import Pagination from '../pagination/pagination'
import BurgerMenu from '../header-menu/burger'
import UrlGeneration from '@lovata/url-generation/url-generation'
import { debounce } from 'throttle-debounce'
import request from 'oc-request'

export default new (class Filter {
    constructor() {
        this.filterContainer = "_filter"
        this.filterContainerProduct = "_filter-product" //для определения фильтра на странице категории и поиске

        this.filterMobileContainer = "_filterMobileContainer"
        this.filterMobilePopupBtn = "_filterMobile"
        this.filterMobilePopupBtnClose = "_filterMobileClose"

        this.filterPopup = "_filtered-popup"
        this.filterPopupBtn = "_filtered-popup-btn"

        this.filterSortingBtn = "_filter-select--sorting"

        this.typeProductBtn = "_preview-type--item"
        this.typeProductBtnActive = "_preview-type--active"

        this.handler()
    }

    handler() {
        const filterContainer = document.querySelector(`.${this.filterContainer}`)

        if (!filterContainer) return

        document.addEventListener("DOMContentLoaded", () => {
            //фильтр на странице категории и поиске
            if(document.querySelector(`.${this.filterContainer}`).classList.contains(`${this.filterContainerProduct}`)) {
                this.init()
            }

            //переключение "Вид товара"
            document.querySelectorAll(`.${this.typeProductBtn}`).forEach((item) => {
                item.addEventListener('click', (obEvent) => {
                    this.typeProductChange(obEvent)
                })
            });

            //открыть попап "фильтр" на мобиле
            document.querySelectorAll(`.${this.filterMobilePopupBtn}`).forEach((item) => {
                item.addEventListener('click', (obEvent) => {
                    obEvent.preventDefault()
                    this.filterMobilePopupToggle()
                })
            });
            //закрыть попап "фильтр" на мобиле
            document.querySelectorAll(`.${this.filterMobilePopupBtnClose}`).forEach((item) => {
                item.addEventListener('click', (obEvent) => {
                    obEvent.preventDefault()
                    this.filterMobilePopupToggle()
                })
            });

            //post,project list page filter category
            document.querySelectorAll('[data-burger-select="filter"] input').forEach((item) => {
                item.addEventListener('change', (obEvent) => {
                    obEvent.preventDefault()
                    let _this = this;

                    if (obEvent.target.closest('[data-type="category"]')) {
                        let text = obEvent.target.closest('div').querySelector('label').textContent;
                        obEvent.target.closest('[data-burger-select="filter"]').querySelector(`.${BurgerMenu.sMenuSelectTitleClass} span`).textContent ='"' + text + '"';
                    }
                    //листинг проектов
                    if(document.querySelector('#_projects-list')) {
                        document.querySelector('#_projects-list').classList.add('_preloader');
                        let categoryId = [];
                        obEvent.target.closest('[data-burger-select="filter"]').querySelectorAll(`input`).forEach((item) => {
                            if(item.checked) {
                                categoryId.push(item.value)
                            }
                        });

                        request.sendData('StsProjectList::onAjaxRequest', {
                            data: {
                                categoryId,
                            },
                            update: {
                                'projects-list/projects-list':'#_projects-list',
                                'projects-list-filter/projects-list-filter':'#_projects-list-filter',
                                'pagination/pagination':'._pagination'
                            },
                            complete: function() {
                                Pagination.init();
                                BurgerMenu.selectMenuToggle();
                                document.querySelector('#_projects-list').classList.remove('_preloader');
                                _this.initRemoveBtnProject();
                            }
                        });
                    }
                    //листинг постов
                    if(document.querySelector('#_articles-list')) {
                        document.querySelector('#_articles-list').classList.add('_preloader');

                        let categoryId = [];
                        obEvent.target.closest('[data-burger-select="filter"]').querySelectorAll(`input`).forEach((item) => {
                            if(item.checked) {
                                categoryId.push(item.value)
                            }
                        });

                        request.sendData('ArticleList::onAjaxRequest', {
                            data: {
                                categoryId,
                            },
                            update: {
                                'articles-list/articles-list':'#_articles-list',
                                'pagination/pagination':'._pagination'
                            },
                            complete: function() {
                                Pagination.init();
                                BurgerMenu.selectMenuToggle();
                                document.querySelector('#_articles-list').classList.remove('_preloader');
                            }
                        });
                    }
                })
            });

            if(document.querySelector('#_category-product-list')) { //листинг товаров
                this.initRemoveBtnProduct();

                //фильтрация по checkbox, radio
                document.querySelectorAll(`.${this.filterContainer} input[type="checkbox"], .${this.filterContainer} input[type="radio"]`).forEach((item) => {
                    item.addEventListener('change', (obEvent) => {
                        obEvent.preventDefault()
                        UrlGeneration.init();
                        let _this = this;
                        //console.log(obEvent.target.closest('[data-filter-name]'));
                        //obEvent.target.closest('[data-filter-name]').forEach((element) => {
                            let filterName = obEvent.target.closest('[data-filter-name]').getAttribute('data-filter-name');
                            _this.filteredChekUrl(filterName)
                        //});

                        UrlGeneration.update();
                        const debounceFunc = debounce(1500, () => {
                            this.filteredProduct();
                        });

                        debounceFunc();
                    })
                });
            }
        })
    }

    init() {
        //ширина свойств, чтобы ничего не двигалось при увеличении жирности текста
        document.querySelectorAll('._filter-item').forEach((item) => {
            item.style.width = item.offsetWidth + 'px';
        });
    }
    initRemoveBtnProduct() {
        //product list page filter remove - удалить свойство фильтра
        if(document.querySelector('._filtered-product-list-remove')) {
            document.querySelectorAll('._filtered-product-list-remove').forEach((item) => {
                item.addEventListener('click', (obEvent) => {
                    obEvent.preventDefault()
                    let filterName = obEvent.target.closest('._filtered-product-list-remove').getAttribute('data-filter');
                    let filterValue = obEvent.target.closest('._filtered-product-list-remove').getAttribute('data-filter-value');

                    UrlGeneration.init();
                    if(filterValue) {
                        this.filteredChekUrl(filterName, filterValue)
                    }
                    else {
                        UrlGeneration.remove(filterName);
                    }
                    UrlGeneration.update();
                    this.filteredProduct('product-list');
                })
            });
        }
        //product list page filter all remove - сбросить фильтр
        if(document.querySelector('._filtered-product-list-removeall')) {
            document.querySelectorAll('._filtered-product-list-removeall').forEach((item) => {
                item.addEventListener('click', (obEvent) => {
                    UrlGeneration.init();
                    document.querySelectorAll('._filtered-product-list-remove').forEach((element, index) => {
                        let filterName = element.getAttribute('data-filter');
                        UrlGeneration.remove(filterName);
                    });
                    UrlGeneration.update();
                    this.filteredProduct('product-list');

                    document.querySelectorAll(`.${this.filterContainer} input`).forEach((element_input, index) => {
                        if(element_input.checked) {
                            element_input.checked = false
                        }
                    });
                })
            });
        }
        //product list page filter show - отображение отфильтрованных товаров
        if(document.querySelector(`.${this.filterPopupBtn}`)) {
            document.querySelectorAll(`.${this.filterPopupBtn}`).forEach((item) => {
                item.addEventListener('click', (obEvent) => {
                    obEvent.preventDefault()
                    this.filteredProduct('product-list');
                    if(window.innerWidth < 768) {
                        this.filterMobilePopupToggle()
                    }
                })
            });
        }
    }
    initRemoveBtnProject() {
        //project list page filter category remove
        if(document.querySelectorAll('._projects-list-filter-remove')) {
            document.querySelectorAll('._projects-list-filter-remove').forEach((item) => {
                item.addEventListener('click', (obEvent) => {
                    obEvent.preventDefault()
                    let categoryId = obEvent.target.closest('._projects-list-filter-remove').getAttribute('data-category-id');

                    document.querySelector('[data-burger-select="filter"]').querySelectorAll(`input`).forEach((item) => {
                        if(item.value == categoryId) {
                            item.checked = false;
                            item.dispatchEvent(new Event('change'));
                        }
                    });
                })
            });
        }
    }
    filterMobilePopupToggle() {
        document.querySelector(`.${this.filterMobileContainer}`).classList.toggle('opacity-0')
        document.querySelector(`.${this.filterMobileContainer}`).classList.toggle('invisible')
        document.querySelector(`.${this.filterMobileContainer}`).classList.toggle('opacity-100')
        document.querySelector(`.${this.filterMobileContainer}`).classList.toggle('visible')
    }
    typeProductChange(obEvent) {
        document.querySelectorAll(`.${this.typeProductBtn}`).forEach((item) => {
            item.classList.remove(this.typeProductBtnActive)
        });

        obEvent.target.closest(`.${this.typeProductBtn}`).classList.add(this.typeProductBtnActive)
        let type = document.querySelector(`.${this.typeProductBtnActive}`).getAttribute('data-type')
        let page = document.querySelector(`.${Pagination.paginationActive}`).getAttribute('data-page')
        let sort = document.querySelector(`.${this.filterSortingBtn} .select__input`).getAttribute('value')

        document.querySelector('#_category-product-list').classList.add('_preloader');

        request.sendData('StsProductList::onRemeberProductItemCardType', {
            data: {
                product_item_card_type: type,
                page,
                sort
            },
            update: {
                'category-product-list/category-product-list':'#_category-product-list'
            },
            complete: function() {
                document.querySelector('#_category-product-list').classList.remove('_preloader');
            }
        });
    }
    //сортировка товаров
    filterSorting(sort) {
        let page = document.querySelector(`.${Pagination.paginationActive}`).getAttribute('data-page')
        document.querySelector('#_category-product-list').classList.add('_preloader');

        request.sendData('StsProductList::onRemeberProductItemCardType', {
            data: {
                sort,
                page
            },
            update: {
                'category-product-list/category-product-list':'#_category-product-list',
                'pagination/pagination':'._pagination'
            },
            complete: function() {
                Pagination.init();
                document.querySelector('#_category-product-list').classList.remove('_preloader');
            }
        });
    }
    //запрос фильтрации товаров
    filteredProduct(type = null) {
        let page = 1
        if(document.querySelector(`.${Pagination.paginationActive}`)) {
            page = document.querySelector(`.${Pagination.paginationActive}`).getAttribute('data-page')
        }
        let sort = document.querySelector(`.${this.filterSortingBtn} .select__input`).getAttribute('value')
        let _this = this;
        let update = {
            'filter/popup':'#_filtered-popup',
        };

        if(type == 'product-list') {
            update = {
                'category-product-list/category-product-list':'#_category-product-list',
                'filter/filteredProperties':'#_filtered-product-list',
                'pagination/pagination':'._pagination'
            };
        }

        request.sendData('ProductList::onAjaxRequest', {
            data: {
                sort,
                page
            },
            update,
            complete: function() {
                BurgerMenu.selectMenuToggle();
                _this.initRemoveBtnProduct();
                Pagination.init();
                if(type == 'product-list') {
                    _this.filteredProductPopupHide()
                }
                else {
                    _this.filteredProductPopupShow()
                }
            }
        });
    }
    filteredProductPopupShow() {
        if(window.innerWidth < 768) {
            document.querySelectorAll(`._filterMobileContainer .${this.filterPopup}`).forEach((item) => {
                item.classList.add('popup-show');
                item.classList.remove('sm:opacity-0');
                item.classList.remove('sm:invisible');
                item.classList.remove('hidden');
            });
        }
        else {
            document.querySelectorAll(`.${this.filterPopup}`).forEach((item) => {
                item.classList.add('popup-show');
                item.classList.remove('sm:opacity-0');
                item.classList.remove('sm:invisible');
            });
        }
        /*setTimeout(() => {
            $(`.${this.filterPopup}`).fadeOut();
        }, 1500);*/
    }
    filteredProductPopupHide() {
        if(window.innerWidth < 768) {
            document.querySelectorAll(`._filterMobileContainer .${this.filterPopup}`).forEach((item) => {
                item.classList.remove('popup-show');
                item.classList.add('sm:opacity-0');
                item.classList.add('sm:invisible');
                item.classList.add('hidden');
            });
        }
        else {
            document.querySelectorAll(`.${this.filterPopup}`).forEach((item) => {
                item.classList.remove('popup-show');
                item.classList.add('sm:opacity-0');
                item.classList.add('sm:invisible');
            });
        }
    }
    //получить зачение input checkbox, radio и вставиь в url актуальное
    filteredChekUrl(filterName, filterValue = null) {
        if(filterName !== '') {
            let properities = [];
            let inputs = document.querySelectorAll('._filterDescContainer [data-filter-name="'+filterName+'"] input');
            if(window.innerWidth < 768) {
                inputs = document.querySelectorAll('._filterMobileContainer [data-filter-name="'+filterName+'"] input');
            }

            inputs.forEach((element_input) => {
                if(element_input.checked && filterValue != element_input.value) {
                    properities.push(element_input.value)
                }
                if(filterValue && filterValue == element_input.value) {
                    element_input.checked = false
                }
            });

            if(properities.length > 0 ) {
                UrlGeneration.set(filterName, [...new Set(properities)]);
            }
            else {
                UrlGeneration.remove(filterName);
            }
        }
    }
})()
